<template>
    <div class="marriage-bottom-button-box dsp-flex">
        <div class="marriage-bottom-button-box-half">
            <button class="marriage-bottom-button marriage-bottom-button-left" @click="clickVip"><span>终身会员免费解锁</span></button>
        </div>
        <div class="marriage-bottom-button-box-half">
            <button class="marriage-bottom-button marriage-bottom-button-right" @click="clickPay"><span>{{ userData && parseInt(userData.vip) < 30 ? productData.price+'元解锁本页报告' : '特权免费解锁' }}</span></button>
        </div>
        <div class="marriage-bottom-heart">
            <div class="marriage-content-score">
                <span class="score-num">{{ marriageData.totalScore }}<span class="score-text">分</span></span>
            </div>
        </div>
    </div>
</template>

<script>
import { ACTIVITY_DOM } from '../../modules/dom';

export default {
    name: 'MarriageBottomButton',
    props: {
        clickFunc: {
            type: Function,
            default() {
                return function(){}
            }
        },
    },
    data() {
        return {
            buttonLocked: false
        }
    },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        marriageProductData() {
            return this.$store.state.pay.marriageProductData;
        },
        marriageData() {
            return this.$store.state.marriage.marriageData;
        },
        productData() {
            return this.$store.state.pay.marriageProductData[this.$store.state.marriage.marriageData.pid];
        },
    },
    methods: {
        clickVip() {
            if((this.userData && parseInt(this.userData.vip) >= 30)) {
                if(this.clickFunc && typeof(this.clickFunc) == 'function') {
                    this.clickFunc();
                }
            }else {
                // 显示998购买VIP页面
                this.$store.state.user.showActDayLuckPop = true;
                setTimeout(() => {
                    ACTIVITY_DOM.updateActivityDayLuckDom();
                }, 100);
            }
        },
        clickPay() {
            if(this.buttonLocked) { return; }
            this.buttonLocked = true;
            if(this.clickFunc && typeof(this.clickFunc) == 'function') {
                this.clickFunc();
                setTimeout(() => {
                    this.buttonLocked = false;
                }, 500);
            }

        }
    }
}
</script>